module.exports = __webpack_public_path__ + "static/Publishing_Services-e63408e2f47de8cc08160512ee8e2ac6.svg";